import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';

import withAuthGuard from '../withAuthGuard';

import Receipt from '../../components/MyAccount/invoices/Receipt';

import { selectActivePlanSubscription, selectIsSubscriptionFromApps, selectSubscriptionMethodId } from '../../queries/selectors/products';
import { selectCurrentContentFichaPath } from '../../queries/selectors/contents';
import { selectSubscriberConfig, selectReturnURLPath, selectProductsEntities } from '../../queries/selectors/bootstrap';
import { requestAsync } from '../../queries/actions';
import { getReceiptsBySubscriber } from '../../queries/invoice';

import withMembershipPurchased from '../withMembershipPurchased';
import withPaymentStatus from '../withPaymentStatus';
import { selectClient, selectCancellationMethod } from '../../global-selectors';
import { selectCurrentPaymentMethod } from '../../queries/selectors/payment';
import { selectUserData } from '../../queries/selectors/user';

const mapStateToProps = (state) => ({
  userPlan: selectActivePlanSubscription(state),
  path: selectReturnURLPath(state) || selectCurrentContentFichaPath(state) + 'my-account',
  subscriber: selectSubscriberConfig(state),
  isSubscriptionFromApps: selectIsSubscriptionFromApps(state),
  subscriptionMethodId: selectSubscriptionMethodId(state),
  paymentMethod: selectCurrentPaymentMethod(state),
  client: selectClient(state),
  user: selectUserData(state),
  cancellationFlow: selectCancellationMethod(state),
  products: selectProductsEntities(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getReceipts: (data) => requestAsync(getReceiptsBySubscriber, data)
}, dispatch);

export default compose(
  injectIntl,
  withPaymentStatus,
  withMembershipPurchased,
  connect(mapStateToProps, mapDispatchToProps),
  withAuthGuard({ toLoginURL: true })
)(Receipt);
